import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

function InboxPage() {
  return (
    <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-3xl">Inbox</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            This page will contain incoming notifications and tasks.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

export default InboxPage;
